import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "components/hds";

import { Modal } from "components";
import { useScenes } from "contexts/Scenes";
import Share from "views/Projects/views/Scene/tabs/Share";

const ShareButton = () => {
	const { t } = useTranslation();
	const { current: currentScene } = useScenes();
	const [visible, setVisible] = useState(false);

	if (!currentScene) {
		return <span>{/* Do not delete this span */}</span>;
	}

	return (
		<>
			{/* §8's default button: white, 1px border, 6px radius. `inline` gives the
			    40px auto-width variant, which matches the 40px avatar beside it. */}
			<Button
				className="shareButton"
				inline
				icon={<Icon name="ShareIcon" />}
				onClick={() => setVisible(true)}
			>
				{String(t("app.SceneViewer.flexLayout.Share"))}
			</Button>
			<Modal
				title={String(t("app.SceneViewer.flexLayout.Share"))}
				open={visible}
				onCancel={() => setVisible(false)}
				footer={false}
				size="large"
			>
				<Share />
			</Modal>
		</>
	);
};

export default ShareButton;
